












import { defineComponent, ref } from '@nuxtjs/composition-api';

function makeFaqJsonLd(elements) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: elements.map(el => ({
      '@type': 'Question',
      name: el.custom_fields.find(cf => cf.key === 'title')?.value_string,
      acceptedAnswer: {
        '@type': 'Answer',
        text: el.custom_fields.find(cf => cf.key === 'answer')?.value_string_area.trim()
      }
    }))
  };
}

export default defineComponent({
  name: 'CmsComponentsFaqContainer',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  setup() {
    const openFaqId = ref<number | null>(null);

    const toggleFaq = (faqId: number) => {
      if (openFaqId.value === faqId) {
        openFaqId.value = null;
      } else {
        openFaqId.value = faqId;
      }
    };

    return {
      openFaqId,
      toggleFaq
    };
  },
  head() {
    return {
      script: [{ type: 'application/ld+json', json: makeFaqJsonLd(this.data.elements) }]
    };
  }
});
